import { RemoteConfigVariables } from 'fitbeat.models';
import React from 'react';
import { translate } from 'react-i18next';
import { Platform, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import WorkoutBottomImage from '../../assets/images/Fitbeat-focus-HRM.jpg';
import { Button, ButtonSize, ButtonTypes } from '../../components';
import { BluetoothServiceSingleton } from '../../HomeWorkouts/utils/BluetoothServiceSingleton';
import { RetryPolicy } from '../../HomeWorkouts/utils/IBluetoothService';
import Theme from '../../theme';
import { toggleHeartRateMonitorModalVisible} from '../../ui';
import { FirebaseRemoteConfig } from '../../utils/FirebaseRemoteConfig';
import { openInAppWebViewerInBackground } from '../../utils/inAppWebViewer';
import { defaultScale, scaleImageAspectRatio } from '../../utils/scaling';
import { TrackingImageTile } from './TrackingImageTile';

const isWeb = Platform.OS === 'web';

class NoHeartRateMonitorImageTileComponent extends React.Component<any, any> {
  public openHeartRateStoreLink = async () => {
    const url = await FirebaseRemoteConfig.getRemoteConfigValue(
      RemoteConfigVariables.tigernovo_heart_rate_shop_url,
    );
    openInAppWebViewerInBackground(url);
  }

  public openHeartRateMonitorModal = () => {
    const bluetoothService = BluetoothServiceSingleton.getBluetoothService();
    const { toggleHRMonitorModal } = this.props;
    bluetoothService.setRetryPolicy(RetryPolicy.StopAfterRetryCountExceeded);
    toggleHRMonitorModal(true);
  }

  public render() {
    const {
      t,
    } = this.props;
    return (
      <TrackingImageTile
          imageSource={WorkoutBottomImage}
          containerStyle={styles.imageStyle}
          title={t('trackWorkoutMetrics')}
          subtitle={t('addHeartRateMonitor')}
          useGradient={true}
          actions={
            <View>
              <Button
                title={t('grabHRMonitor')}
                onPress={this.openHeartRateStoreLink}
                fontColor={Theme.WHITE}
                buttonType={ButtonTypes.OUTLINE}
                size={ButtonSize.MEDIUM}
                containerStyle={[styles.scanButtonContainer, { backgroundColor: Theme.PRIMARY }]}
              />
              {!isWeb && <Button
                title={t('setHRMonitor')}
                onPress={this.openHeartRateMonitorModal}
                fontColor={Theme.PRIMARY}
                buttonType={ButtonTypes.OUTLINE}
                size={ButtonSize.MEDIUM}
                containerStyle={[styles.scanButtonContainer]}
              />}
            </View>}
        />
    );
  }
}

const styles = StyleSheet.create({
  imageStyle: {
    width: '100%',
    ...Platform.select({
      web: {
        height: '30vh',
      },
      default: {
        aspectRatio: scaleImageAspectRatio(1.55),
      },
    }),
  },
  scanButtonContainer: {
    marginVertical: defaultScale(5),
  },
});

const mapDispatchToProps = (dispatch) => {
  return {
    toggleHRMonitorModal: (visible) => dispatch(toggleHeartRateMonitorModalVisible(visible)),
  };
};

export const NoHeartRateMonitorImageTile =
  connect(null, mapDispatchToProps)
  (translate(['workoutHistory'])
  (NoHeartRateMonitorImageTileComponent));
